import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import RippleButton from "../../components/common/RippleButton";
import ButtonForAll from "../../components/common/ButtonForAll";
import IconComponent from "../../components/common/IconComponent";
import { FaFilter } from "react-icons/fa";
import { Button } from "@progress/kendo-react-buttons";
import {
  clearHotelQuotationFilterDetails,
  setHotelQuotationFilterDetails,
} from "./quotationSlice";

const HotelQuotationFilter: React.FC = () => {
  const gridRef = useRef<any>(null);
  const BTNRef = useRef<any>(null);

  const dispatch = useAppDispatch();
  // const location = useLocation();
  // const filterContactID = location.state?.ContactID;
  // const filterInquiryID = location.state?.InquiryID;
  // const filterLeadID = location.state?.LeadID;
  const loading = useAppSelector((state) => state.lead.loading);
  const [expand, setExpand] = useState("");
  const HotelQuotationFilterDetails = useAppSelector(
    (state) => state.quotation.HotelQuotationFilterDetails
  );

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [HotelQuotationFilterDetails]);

  useEffect(() => {
    // const idMapping: Partial<
    //   Pick<
    //     IQuotationFilterDetails,
    //     "filterContactID" | "filterInquiryID" | "filterLeadID"
    //   >
    // > = { filterContactID, filterLeadID, filterInquiryID };

    // const updatedFilterDetails = Object.entries(idMapping).reduce(
    //   (acc, [key, value]) => {
    //     const typedKey = key as keyof IQuotationFilterDetails;

    //     return {
    //       ...acc,
    //       [typedKey]: HotelQuotationFilterDetails?.[typedKey]
    //         ? `${HotelQuotationFilterDetails[typedKey]}`
    //         : value
    //         ? `${value}`
    //         : "",
    //     };
    //   },
    //   {} as Partial<IQuotationFilterDetails>
    // );

    // if (
    //   Object.values(updatedFilterDetails).some((value) => value) &&
    //   JSON.stringify(updatedFilterDetails) !==
    //     JSON.stringify(QuotationFilterDetails)
    // ) {
    dispatch(
      setHotelQuotationFilterDetails({
        ...HotelQuotationFilterDetails,
        // ...updatedFilterDetails,
      })
    );
    // }
  }, []);

  const handleSubmit = async (values: any) => {
    const insertPayload = {
      // filterContactID:
      //   QuotationFilterDetails?.filterContactID || filterContactID || "",
      // filterLeadID: QuotationFilterDetails?.filterLeadID || filterLeadID || "",
      // filterInquiryID:
      //   QuotationFilterDetails?.filterInquiryID || filterInquiryID || "",
      CustomerName: values?.CustomerName ? values?.CustomerName : "",
      EmailID: values?.EmailID ? values?.EmailID : "",
      MobileNo: values?.MobileNo ? values?.MobileNo : "",
      HotelName: values?.HotelName ? values?.HotelName : "",
    };
    setExpand("");
    dispatch(setHotelQuotationFilterDetails(insertPayload));
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={HotelQuotationFilterDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ExpansionPanel
              className="inquiry-filter-panel m-0"
              title={
                <div>
                  <div>
                    <IconComponent icon={FaFilter} /> Filter Results
                  </div>
                </div>
              }
              expanded={expand === "filter"}
              tabIndex={1}
              onAction={(event: ExpansionPanelActionEvent) => {
                const nativeEvent = event.nativeEvent as KeyboardEvent;
                const ActiveBTN = document.activeElement as HTMLElement;

                if (
                  nativeEvent.type === "keydown" &&
                  nativeEvent.code === "Space"
                ) {
                  nativeEvent.preventDefault();
                  return;
                } else if (
                  nativeEvent.code === "Enter" ||
                  nativeEvent.code === "NumpadEnter"
                ) {
                  nativeEvent.preventDefault();
                  if (ActiveBTN.id === "HotelQuotationSubmitBtn") {
                    BTNRef.current.element.click();
                  } else if (ActiveBTN.id === "ClearHotelQuotationDetail") {
                    setExpand("");
                  }
                  return;
                }

                if (event?.expanded) {
                  setExpand("");
                } else {
                  setExpand("filter");
                }
              }}
            >
              {expand === "filter" && (
                <GridLayout
                  style={{ marginRight: 20, padding: 10 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      name="CustomerName"
                      label="Customer Name"
                      placeholder="Customer Name"
                      maxLength="100"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="EmailID"
                      label="Email"
                      placeholder="Email"
                      maxLength="100"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="MobileNo"
                      label="Mobile No"
                      placeholder="Mobile No"
                      maxLength="100"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="HotelName"
                      label="Hotel Name"
                      placeholder="Hotel Name"
                      maxLength="100"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                      marginTop: 20,
                    }}
                  >
                    <RippleButton
                      id={"ClearContactDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="error"
                      style={{ marginRight: 10 }}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        dispatch(clearHotelQuotationFilterDetails());
                      }}
                    >
                      Clear
                    </RippleButton>
                    <ButtonForAll
                      id={"HotelQuotationSubmitBtn"}
                      label={"Filter"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                    />
                    <RippleButton
                      id={"ClearHotelQuotationDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => setExpand("")}
                    >
                      Cancel
                    </RippleButton>
                  </GridLayoutItem>
                </GridLayout>
              )}
            </ExpansionPanel>
            {
              <Button
                style={{ opacity: 0, position: "absolute", left: -50 }}
                ref={BTNRef}
                type="submit"
                disabled={!formRenderProps.allowSubmit || loading}
              >
                Filter
              </Button>
            }
          </FormElement>
        )}
      />
    </>
  );
};

export default HotelQuotationFilter;
